import axios from 'axios';
import { deleteRequest, get, post, put } from 'helpers/api';
import camelcaseKeys from 'camelcase-keys';

export const SET_SHADOWS = 'SET_SHADOWS';
export function loadShadows() {
  return async (dispatch, getState) => {
    dispatch({
      type: SET_SHADOWS,
      shadows: await get(getState().urls.index),
    });
  };
}

export const SELECT_SHADOW = 'SELECT_SHADOW';
export function selectShadow(shadow) {
  return {
    type: SELECT_SHADOW,
    shadow,
  };
}

export const ADD_SHADOW = 'ADD_SHADOW';
export const CREATING_SHADOW = 'CREATING_SHADOW';
export const DONE_CREATING_SHADOW = 'DONE_CREATING_SHADOW';
export function createShadow(grid) {
  return async (dispatch, getState) => {
    dispatch({ type: CREATING_SHADOW });

    try {
      const shadow = await post(getState().urls.index, { gridId: grid.id });
      dispatch({ type: ADD_SHADOW, shadow });
      dispatch({ type: SELECT_SHADOW, shadow });
    } finally {
      dispatch({ type: DONE_CREATING_SHADOW });
    }
  };
}

export function duplicateShadow(shadow) {
  return async (dispatch, getState) => {
    const duplicate = await post(`${getState().urls.index}/${shadow.id}/duplicate`);
  
    dispatch({
      type: ADD_SHADOW,
      shadow: duplicate,
    });
  };
}

export function importShadow(file) {
  return async (dispatch, getState) => {
    const formData = new FormData();
    formData.append('file', file);

    let response;
    try {
      response = await axios.post(
        `${getState().urls.index}/import`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
    } catch (error) {
      let errors;
      if (error.response) {
        errors = error.response.data.errors;
      }

      throw errors || error;
    }
  
    dispatch({
      type: ADD_SHADOW,
      shadow: camelcaseKeys(response.data, { deep: true }),
    });
  };
}

export function exportShadow(shadow, asCsv) {
  return async (_dispatch, getState) => {
    window.open(`${getState().urls.index}/${shadow.id}/export.${asCsv ? 'csv' : 'xlsx'}`);
  };
}

export const UPDATE_SHADOW = 'UPDATE_SHADOW';
export function updateShadow(shadow, changes) {
  return async (dispatch) => {
    await put(shadow.apiUrl, { shadow: changes });
    dispatch({
      type: UPDATE_SHADOW,
      shadow: { ...shadow, ...changes },
    });
  };
}

export const REMOVE_SHADOW = 'REMOVE_SHADOW';
export function deleteShadow(shadow) {
  return async (dispatch, getState) => {
    await deleteRequest(`${getState().urls.index}/${shadow.id}`);
    dispatch({
      type: REMOVE_SHADOW,
      shadow,
    });
  };
}

export const MARK_SHADOWS_DIRTY = 'MARK_SHADOWS_DIRTY';
export function markAsDirty() {
  return {
    type: MARK_SHADOWS_DIRTY,
  };
}
